import { LoanDocumentDto, JobDocumentDto } from 'client';
import React, { useEffect, useState } from 'react';
import { UploadDocumentBox } from './UploadDocumentBox';

type createDocumentViewProps = {
	crmId: string;
	modal: JSX.Element;
	documents: LoanDocumentDto[];
	setShowLoadingModal: any;
	documentTypes: JobDocumentDto[];
	setCompleted: any;
};

export const CreateDocumentView = ({
	crmId,
	modal,
	documents,
	documentTypes,
	setShowLoadingModal,
	setCompleted,
}: createDocumentViewProps) => {
	const [isValidBox, setIsValidBox] = useState<any[]>([]);

	const setIsValid = (type: string, isValid: boolean) => {
		let newIsValid = [...isValidBox];
		const index = newIsValid.findIndex((value) => value.type === type);
		if (index !== -1) {
			newIsValid[index] = { type: type, valid: isValid };
			setIsValidBox(newIsValid);
		}
	};

	useEffect(() => {
		setIsValidBox(
			documentTypes.map((value) => {
				const isIndexValid = documents.findIndex(
					(document) => document.documentType === value.type
				);
				return { type: value.type, valid: isIndexValid !== -1 };
			})
		);
		//eslint-disable-next-line
	}, [documentTypes]);

	useEffect(() => {
		setCompleted(isValidBox.every((value) => value.valid === true));
		//eslint-disable-next-line
	}, [isValidBox]);

	return (
		<div>
			{modal}
			{documentTypes.map((documentType: JobDocumentDto, index: number) => {
				return (
					<div key={`${documentType.type}-${index}`}>
						<h3 className="body-bold gris-6" style={{ marginTop: 32 }}>
							{index + 1} - {documentType.title}
						</h3>
						<p className="body gris-6" style={{ marginTop: 4, marginBottom: 12 }}>
							{documentType.subtitle}
						</p>
						<UploadDocumentBox
							key={`${documents.length}-${documentType.type}`}
							crmId={crmId}
							setCompleted={setIsValid}
							setShowLoadingModal={setShowLoadingModal}
							documentType={documentType.type ? documentType.type : ''}
							uploadedDocument={documents.filter(
								(document) => document.documentType === documentType.type
							)}
						/>
					</div>
				);
			})}
		</div>
	);
};
